import {
	ErrorArgs,
	ErrorType,
	EventAction,
	EventArgs,
	EventCategory,
	EventKeys,
	EventLabel,
	EventType,
	EventValues,
	FormErrors,
	Identifiers,
} from './analytics-interfaces';
import AbstractAnalytics from './abstract-analytics';
import MockAnalytics from './mock-analytics';
import { GoogleAnalytics } from './google-analytics';
import { Configuration } from '../hooks/useMock';

export type ChoiceType = string | undefined;

export default class Analytics {
	private static instance: AbstractAnalytics;

	static getInstance(configuration?: Configuration): AbstractAnalytics {

		if (!Analytics.instance) {
			Analytics.instance = configuration?.isMockAllowed
				? new MockAnalytics()
				: new GoogleAnalytics();
		}
		return Analytics.instance;
	}
}

export type { EventArgs, ErrorArgs, FormErrors };
export {
	EventKeys,
	EventValues,
	EventLabel,
	EventCategory,
	EventAction,
	EventType,
	ErrorType,
	Identifiers,
};
